<template>
    <div class="container py-5">
        <h2>{{ $t('modelingCreation') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modelings' }">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/settings/modelings'">
                        {{ $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    {{ $t('create') }}
                </li>
            </ol>
        </nav>
         <div class="row mb-3 ">
            <div class="col-md-3">
                <label class="form-label" for="name">{{ $t('modelingName') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name"  placeholder="Enter modeling name">
            </div>
            <div class="col-md-6">
                <label class="form-label">{{ $t('currency') }}</label>
                <input class="form-control" v-model="data.currency">
            </div>
        </div>
        <div class="row col-md-12">
            <label class="form-label">{{ $t('groups') }}</label>
            <div class="col-md-3" v-for="(item, i) in groups" :key="i">
                <div class="input-group mb-3">
                    <label class="form-control readonly" :for="'group_' + i">{{item.name}}</label>
                    <div class="input-group-text">
                        <input class="form-check-input mt-0" type="checkbox" :id="'group_' + i" @change="groupCheck(item, $event)" :checked="isGroupChecked(item)">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import ModelingApi from "../../../api/server/modeling";
import GroupApi from "../../../api/server/group";

export default {
   mounted() {
        this.requestData();
    },
    methods: {
        async onSubmit() {
            this.data.content = JSON.stringify(this.content);
            await ModelingApi.modelingCreate(this.data);
            this.$router.push('/settings/modelings')
        },
        async requestData() {
            this.groups = await GroupApi.list();
        },
        groupCheck(group, event) {
            if(!this.content.groups) this.content.groups = [];
            if(event.target.checked) {
                var index =  this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index < 0) {
                    this.content.groups.push({ "groupId": group.id })
                }
            } else {
                var index = this.content.groups.findIndex(f=>f.groupId == group.id);
                if(index >= 0) {
                    this.content.groups.splice(index, 1);
                }
            }
        },
        isGroupChecked(item) {
            return this.content["groups"]?.findIndex(f => f["groupId"] == item.id) >= 0;
        }
    },
    data() {
        return {
            groups: [],
            content: {},
            data: {
                name: "",
                currency: "",
                content: "{}"
            }
        }
    }
};

</script>
